export default "__VITE_ASSET__OxgYjgvu__"